export const environment = {
  production: false,
  api: {
    appVersion: '4.4.0',
    user: 'https://auth-rfa-new.intigo.tn/api',
    backendBase: 'https://admin-api-new.intigo.tn/api',
    userFromBackend: 'https://admin-api-new.intigo.tn/api/users',
    group: 'https://admin-api-new.intigo.tn/api/group',
    permission: 'https://admin-api-new.intigo.tn/api/permission',
    business: 'https://admin-api-new.intigo.tn/api/business',
    bordereau: 'https://admin-api-new.intigo.tn/api/bordereau',
    deliveryRequest: 'https://admin-api-new.intigo.tn/api/deliveryRequest',
    pickUp: 'https://admin-api-new.intigo.tn/api/pickup',
    conciergerieRequest: 'https://admin-api-new.intigo.tn/api/conciergerieRequest',
    workingDay: 'https://admin-api-new.intigo.tn/api/workingday',
    notificationsBackend: 'https://admin-api-new.intigo.tn/api/notification',
    fcmTokens: 'https://notif.intigo.tn/api/v1/fcmtokens',
    payment: 'https://app.paymee.tn',
    jobRequest: 'https://admin-api-new.intigo.tn/api/jobRequests',
    jobPositions: 'https://admin-api-new.intigo.tn/api/jobPositions',
    jobRequestHistory: 'https://admin-api-new.intigo.tn/api/jobRequestHistory',
    frontEndUrl: 'https://my.intigo.tn',
    packingSlip: 'https://admin-api-new.intigo.tn/api/packingSlip',
    serverUrl: 'https://admin-api-new.intigo.tn/api',
    finance: 'https://admin-api-new.intigo.tn/api/finance',
    mobileApp: 'https://admin-api-new.intigo.tn/api/mobileApp',
    analytics: 'https://admin-api-new.intigo.tn/api/stats',
    centrale: 'https://admin-api-new.intigo.tn/api/centrale',
    driver: 'https://admin-api-new.intigo.tn/api/driver',
    support: 'https://admin-api-new.intigo.tn/api/tickets',
    partnerMicroService: 'https://partner-api-new.intigo.tn/api',
    driverMicroService: 'https://driver-api-new.intigo.tn/api',
    // Address and Cities APIs
    cities: 'https://admin-api-new.intigo.tn/api/cities',
    addresses: 'https://admin-api-new.intigo.tn/api/addresses',
  },
  paymentVendor: '7986',
  paymentApiKey: '782a497b2798a2ef45f5afda374beb9992dc0cf8',
  firebase: {
    apiKey: 'AIzaSyAzZ2Mr5tGHT2hDP99eoXPZ-oTkvc4Dkz8',
    authDomain: 'intigo-notifications.firebaseapp.com',
    databaseURL: 'https://intigo-notifications.firebaseio.com',
    projectId: 'intigo-notifications',
    storageBucket: 'intigo-notifications.appspot.com',
    messagingSenderId: '19182138526',
    appId: '1:19182138526:web:5aeed682d4da0f4e0bf78f',
    measurementId: 'G-DY2XP7WWMZ',
  },
};
